import { ErrorMessage, Field, Form, Formik } from "formik";
import moment from 'moment';
import "moment-timezone";
import React, { Component } from "react";
import { Button, ControlLabel } from "react-bootstrap";
import InputMask from "react-input-mask";
import Alert from 'react-s-alert';
import * as Yup from "yup";
import AuthContext from '../auth-context';
import FormikDatetime from '../Shared/FormikDateTime';
import FormikFormControl from '../Shared/Forms/FormikFormControl';
import CoachingPortalService from '../utils/CoachingPortalService';

class SetupCoachingPortalForm extends Component {
  static contextType = AuthContext;

  state = {
    serverErrors: {}
  }

  render() {
    const authStore = this.context

    const validationSchema = Yup.object().shape({
      parent_region: Yup.string().required("is required"),
      parent_first_name: Yup.string().required("is required").max(30, "maximum 30 characters"),
      parent_last_name: Yup.string().required("is required").max(30, "maximum 30 characters"),
      parent_email: Yup.string().required("is required").max(100, "maximum 100 characters").email("doesn't look like a valid email address"),
      parent_mobile: Yup.string().matches(/04\d\d \d\d\d \d\d\d/, "must be an Australian mobile number"),

      student_region: Yup.string().required("is required"),
      student_first_name: Yup.string().required("is required").max(30, "maximum 30 characters"),
      student_last_name: Yup.string().required("is required").max(30, "maximum 30 characters"),
      student_email: Yup.string().required("is required").max(100, "maximum 100 characters").email("doesn't look like a valid email address"),
      student_mobile: Yup.string().matches(/04\d\d \d\d\d \d\d\d/, "must be an Australian mobile number"),

      starts: Yup.date().required("is required").when('ends', {
        is: v => v != null,
        then: s => s.max(Yup.ref('ends'), 'must be before End'),
      }),
      ends: Yup.date().min(Yup.ref('starts'), 'must be after Begin').required("is required"),
      account_number: Yup.string().required('is required').max(30, "maximum 30 characters"),
      notes: Yup.string().max(700, "maximum 700 characters"),
    });

    const { deal, onCancelSubmit } = this.props
    if (!deal) return null

    const parent = deal.lm_contact
    const student = deal.related_contacts.find((c) => c.contact_type === 'STUDENT') || {}

    const profile = authStore.profile

    const notes = `Created by ${profile.first_name} ${profile.last_name} (${profile.email})\nFrom deal #${deal.id}\nhttps://m1-dashboard.herokuapp.com/m1/deals/${deal.id}\n\nCoach Notes from Sales:\n${deal.notes_coach}`

    const createAccountNumber = (deal, last_name, first_name, email) => {
      try {
        const emailBits = email.split('@')
        const part1 = ((last_name || '').replace(/[^a-z]/gi, '') || (first_name || '').replace(/[^a-z]/gi, '') || emailBits[0].replace(/[^a-z]/gi, '') || 'M1').toUpperCase()
        const part2 = deal.id
        return part1 + '_' + part2
      } catch (err) {
        return ''
      }
    }
    const initialValues = {
      deal_id: deal.id,

      account_number: createAccountNumber(deal, parent.last_name, parent.first_name, parent.email),
      parent_region: parent.region || '',
      parent_first_name: parent.first_name || '',
      parent_last_name: parent.last_name || '',
      parent_email: parent.email || '',
      parent_mobile: parent.mobile || '',

      student_region: student.region || '',
      student_first_name: student.first_name || '',
      student_last_name: student.last_name || '',
      student_email: student.email || '',
      student_mobile: student.mobile || '',

      starts: moment().toDate(),
      ends: moment().add(365, 'days').toDate(),

      notes: notes
    }
    return (
      <div>
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          isInitialValid={validationSchema.isValidSync(initialValues)}
          onSubmit={(values, { setSubmitting, setErrors }) => {
            setSubmitting(true);
            this.serverErrors = {}
            const { onSubmit } = this.props

            const save = CoachingPortalService.setupAccounts(values)
            save.then(data => {
              Alert.success('Accounts created')
              onSubmit(data, values.account_number, values.starts.toISOString(), values.ends.toISOString())
              setSubmitting(false);
            }).catch(error => {
              let errors = {};
              Object.keys(error.data).map(
                key => (errors[key] = error.data[key].join(", "))
              );
              setErrors(errors);
              setSubmitting(false);
            });
          }}
          render={({
            errors,
            touched,
            isSubmitting,
            values,
            setFieldValue,
            setFieldTouched, isValid
          }) => {
            const { serverErrors } = this.state
            const hasError = (key) => {
              return ((errors[key] && touched[key]) || serverErrors[key]) && "has-error"
            }

            return (
              <Form>
                <div className='row'>
                  <div className='col-md-6' style={{ borderRight: '1px solid #ccc' }}>
                    <h4 style={{ marginTop: 0 }}>Parent</h4>
                    <div className='d-flex'>
                      <div className='d-margin-tight'>
                        <div className={`form-group ${hasError('parent_first_name')}`} >
                          <ControlLabel>First Name</ControlLabel>
                          <Field type="text" name="parent_first_name" className="form-control" />
                          {serverErrors.parent_first_name && <p className='help-block'>{serverErrors.parent_first_name.join(', ')}</p>}
                          <ErrorMessage name="parent_first_name" component="span" className="help-block" />
                        </div>
                      </div>
                      <div className='d-margin-tight'>
                        <div className={`form-group ${hasError('parent_last_name')}`} >
                          <ControlLabel>Last Name</ControlLabel>
                          <Field type="text" name="parent_last_name" className="form-control" />
                          {serverErrors.parent_last_name && <p className='help-block'>{serverErrors.parent_last_name.join(', ')}</p>}
                          <ErrorMessage name="parent_last_name" component="span" className="help-block" />
                        </div>
                      </div>
                    </div>

                    <div className='d-flex'>
                      <div className='d-margin-tight'>
                        <div className={`form-group ${hasError('parent_email')}`} >
                          <ControlLabel>Email</ControlLabel>
                          <Field type="text" name="parent_email" className="form-control" />
                          {serverErrors.parent_email && <p className='help-block'>{serverErrors.parent_email.join(', ')}</p>}
                          <ErrorMessage name="parent_email" component="span" className="help-block" />
                        </div>
                      </div>
                      <div className='d-margin-tight'>
                        <div className={`form-group ${hasError('parent_mobile')}`} >
                          <ControlLabel>Mobile</ControlLabel>
                          <Field type="text" name="parent_mobile" className="form-control"
                            render={({ field }) => {
                              return (
                                <InputMask mask="9999 999 999" {...field} className="form-control" placeholder="Mobile number" />
                              );
                            }}
                          />
                          {serverErrors.parent_mobile && <p className='help-block'>{serverErrors.parent_mobile.join(', ')}</p>}
                          <ErrorMessage name="parent_mobile" component="span" className="help-block" />
                        </div>
                      </div>
                    </div>

                    <FormikFormControl fieldName='parent_region' errors={errors} touched={touched} style={{ width: 200 }}>
                      <ControlLabel>Region</ControlLabel>
                      <Field component="select" name="parent_region" className="form-control">
                        <option value=''>-- select --</option>
                        <option value="ACT">Australian Capital Territory (SSC)</option>
                        <option value="NSW">New South Wales (HSC)</option>
                        <option value="NT">Northern Territory (NTCET)</option>
                        <option value="QLD">Queensland (QCE)</option>
                        <option value="SA">South Australia (SACE)</option>
                        <option value="TAS">Tasmania (TCE)</option>
                        <option value="VIC">Victoria (VCE)</option>
                        <option value="WA">Western Australia (WACE)</option>
                      </Field>
                    </FormikFormControl>
                  </div>

                  <div className='col-md-6'>
                    <h4 style={{ marginTop: 0 }}>Student</h4>
                    <div className='d-flex'>
                      <div className='d-margin-tight'>
                        <div className={`form-group ${hasError('student_first_name')}`} >
                          <ControlLabel>First Name</ControlLabel>
                          <Field type="text" name="student_first_name" className="form-control" />
                          {serverErrors.student_first_name && <p className='help-block'>{serverErrors.student_first_name.join(', ')}</p>}
                          <ErrorMessage name="student_first_name" component="span" className="help-block" />
                        </div>
                      </div>
                      <div className='d-margin-tight'>
                        <div className={`form-group ${hasError('student_last_name')}`} >
                          <ControlLabel>Last Name</ControlLabel>
                          <Field type="text" name="student_last_name" className="form-control" />
                          {serverErrors.student_last_name && <p className='help-block'>{serverErrors.student_last_name.join(', ')}</p>}
                          <ErrorMessage name="student_last_name" component="span" className="help-block" />
                        </div>
                      </div>
                    </div>

                    <div className='d-flex'>
                      <div className='d-margin-tight'>
                        <div className={`form-group ${hasError('student_email')}`} >
                          <ControlLabel>Email</ControlLabel>
                          <Field type="text" name="student_email" className="form-control" />
                          {serverErrors.student_email && <p className='help-block'>{serverErrors.student_email.join(', ')}</p>}
                          <ErrorMessage name="student_email" component="span" className="help-block" />
                        </div>
                      </div>
                      <div className='d-margin-tight'>
                        <div className={`form-group ${hasError('student_mobile')}`} >
                          <ControlLabel>Mobile</ControlLabel>
                          <Field type="text" name="student_mobile" className="form-control"
                            render={({ field }) => {
                              return (
                                <InputMask mask="9999 999 999" {...field} className="form-control" placeholder="Mobile number"
                                />
                              );
                            }}
                          />
                          {serverErrors.student_mobile && <p className='help-block'>{serverErrors.student_mobile.join(', ')}</p>}
                          <ErrorMessage name="student_mobile" component="span" className="help-block" />
                        </div>
                      </div>
                    </div>

                    <FormikFormControl fieldName='student_region' errors={errors} touched={touched} style={{ width: 200 }}>
                      <ControlLabel>Region</ControlLabel>
                      <Field component="select" name="student_region" className="form-control">
                        <option value=''>-- select --</option>
                        <option value="ACT">Australian Capital Territory (SSC)</option>
                        <option value="NSW">New South Wales (HSC)</option>
                        <option value="NT">Northern Territory (NTCET)</option>
                        <option value="QLD">Queensland (QCE)</option>
                        <option value="SA">South Australia (SACE)</option>
                        <option value="TAS">Tasmania (TCE)</option>
                        <option value="VIC">Victoria (VCE)</option>
                        <option value="WA">Western Australia (WACE)</option>
                      </Field>
                    </FormikFormControl>
                  </div>

                </div>


                <div className='row' style={{ borderTop: '1px solid #ccc', paddingTop: 20 }}>
                  <div className='col-md-6'>
                    <div className={`form-group ${hasError('account_number')}`} >
                      <ControlLabel>Account Number</ControlLabel>
                      <Field type="text" name="account_number" className="form-control" />
                      {serverErrors.account_number && <p className='help-block'>{serverErrors.account_number.join(', ')}</p>}
                      <ErrorMessage name="account_number" component="span" className="help-block" />
                    </div>


                  </div>
                  <div className='col-md-6'>

                    <div className='d-flex'>
                      <div className='d-margin-tight'>
                        <FormikFormControl fieldName='starts' errors={errors} touched={touched}>
                          <ControlLabel>Coaching Begins</ControlLabel>
                          <FormikDatetime
                            field="starts"
                            input={{
                              value: moment(values.starts).format("DD MMM YYYY"),
                              onChange: setFieldValue,
                              onBlur: setFieldTouched
                            }}
                            closeOnSelect={true}
                            dateFormat="DD MMM YYYY"
                            timeFormat={false}
                          />
                        </FormikFormControl>
                      </div>
                      <div className='d-margin-tight'>
                        <FormikFormControl fieldName='ends' errors={errors} touched={touched}>
                          <ControlLabel>Coaching Ends</ControlLabel>
                          <FormikDatetime
                            field="ends"
                            input={{
                              value: moment(values.ends).format("DD MMM YYYY"),
                              onChange: setFieldValue,
                              onBlur: setFieldTouched
                            }}
                            closeOnSelect={true}
                            dateFormat="DD MMM YYYY"
                            timeFormat={false}
                          />
                        </FormikFormControl>
                      </div>
                    </div>

                  </div>
                </div>

                <div className={`form-group ${hasError('notes')}`} >
                  <ControlLabel>Admin Notes</ControlLabel>
                  <Field component="textarea" name="notes" className="form-control" />
                  <ErrorMessage name="notes" component="span" className="help-block" />
                </div>

                <div style={{ marginTop: "20px" }}>
                  {onCancelSubmit && <Button onClick={onCancelSubmit} bsSize='small'>Whoops, cancel this</Button>}
                  <Button className='pull-right' disabled={!isValid || isSubmitting} type="submit" bsStyle='info' bsSize='small'>Setup Accounts in Coaching Portal</Button>
                </div>

              </Form>
            )
          }}
        />
      </div>
    );
  }
}
export default SetupCoachingPortalForm